export enum SHAPE_IDS {
  LARGE_SQUARE = "LargeSquare",
  LARGE_HALF_LAP_HORIZONTAL = "LargeHalflapHorizontal",
  LARGE_HALF_LAP_VERTICAL = "LargeHalflapVertical",
  SQUARE = "SquareFreeform",
  LEFT_BOTTOM_TRIANGLE = "LeftBottomTriangle",
  RIGHT_TOP_TRIANGLE = "RightTopTriangle",
  LEFT_TOP_TRIANGLE = "LeftTopTriangle",
  RIGHT_BOTTOM_TRIANGLE = "RightBottomTriangle",
  QUARTER = "Quarter",
  PIXEL = "Pixel",
  BIT = "Bit",
  HALF_LAP_HORIZONTAL = "HalflapHorizontal",
  HALF_LAP_VERTICAL = "HalflapVertical",
  SHIPLAP_HORIZONTAL = "ShiplapHorizontal",
  SHIPLAP_VERTICAL = "ShiplapVertical",
  MINI_SHIPLAP_HORIZONTAL = "MiniShiplapHorizontal",
  MINI_SHIPLAP_VERTICAL = "MiniShiplapVertical",
  HEX = "Hex",
  HEX_90 = "Hex90",
  LARGE_DIAMOND = "LargeDiamond",
  LARGE_DIAMOND_60 = "LargeDiamond60",
  LARGE_DIAMOND_120 = "LargeDiamond120",
  SMALL_DIAMOND = "SmallDiamond",
  SMALL_DIAMOND_60 = "SmallDiamond60",
  SMALL_DIAMOND_120 = "SmallDiamond120",
  LARGE_TRIANGLE_TOP = "LargeTriangleTop",
  LARGE_TRIANGLE_BOTTOM = "LargeTriangleBottom",
  SMALL_TRIANGLE_TOP = "SmallTriangleTop",
  SMALL_TRIANGLE_BOTTOM = "SmallTriangleBottom",
  // Small 90 Triangle variants
  SMALL_90_LEFT_BOTTOM_TRIANGLE = "Small90LeftBottomTriangle",
  SMALL_90_RIGHT_TOP_TRIANGLE = "Small90RightTopTriangle",
  SMALL_90_LEFT_TOP_TRIANGLE = "Small90LeftTopTriangle",
  SMALL_90_RIGHT_BOTTOM_TRIANGLE = "Small90RightBottomTriangle",
  LARGE_HALF_CIRCLE_VERTICAL = "LargeHalfCircleVertical",
  LARGE_HALF_CIRCLE_HORIZONTAL = "LargeHalfCircleHorizontal",
  LARGE_HALF_CIRCLE_VERTICAL_FLIPPED = "LargeHalfCircleVerticalFlipped",
  LARGE_HALF_CIRCLE_HORIZONTAL_FLIPPED = "LargeHalfCircleHorizontalFlipped",
  QUARTER_CIRCLE_BOTTOM_LEFT = "QuarterCircleBottomLeft",
  QUARTER_CIRCLE_BOTTOM_RIGHT = "QuarterCircleBottomRight",
  QUARTER_CIRCLE_TOP_LEFT = "QuarterCircleTopLeft",
  QUARTER_CIRCLE_TOP_RIGHT = "QuarterCircleTopRight",
  HALF_CIRCLE_VERTICAL = "HalfCircleVertical",
  HALF_CIRCLE_HORIZONTAL = "HalfCircleHorizontal",
  HALF_CIRCLE_VERTICAL_FLIPPED = "HalfCircleVerticalFlipped",
  HALF_CIRCLE_HORIZONTAL_FLIPPED = "HalfCircleHorizontalFlipped",
  // Small Half Circle variants
  SMALL_HALF_CIRCLE_VERTICAL = "SmallHalfCircleVertical",
  SMALL_HALF_CIRCLE_HORIZONTAL = "SmallHalfCircleHorizontal",
  SMALL_HALF_CIRCLE_VERTICAL_FLIPPED = "SmallHalfCircleVerticalFlipped",
  SMALL_HALF_CIRCLE_HORIZONTAL_FLIPPED = "SmallHalfCircleHorizontalFlipped",
  ENGRAVED_BACK_SLASH = "EngravedBackSlashFreeform",
  ENGRAVED_FORWARD_SLASH = "EngravedForwardSlashFreeform",
  ENGRAVED_CROSS = "EngravedCrossFreeform",
  ENGRAVED_FOUR_SQUARE = "EngravedFourSquareFreeform",
  ENGRAVED_PARALLEL = "EngravedParallelFreeform",
  ENGRAVED_PARALLEL_VERTICAL = "EngravedParallelVerticalFreeform",
  ENGRAVED_TANGENT = "EngravedTangentFreeform",
  ENGRAVED_TANGENT_90 = "EngravedTangent90Freeform",
  ENGRAVED_TANGENT_180 = "EngravedTangent180Freeform",
  ENGRAVED_TANGENT_270 = "EngravedTangent270Freeform",
  ENGRAVED_CRISS_CROSS = "EngravedCrissCrossFreeform",
  ENGRAVED_CRISS_CROSS_90 = "EngravedCrissCross90Freeform",
  ENGRAVED_CRISS_CROSS_180 = "EngravedCrissCross180Freeform",
  ENGRAVED_CRISS_CROSS_270 = "EngravedCrissCross270Freeform",
  ENGRAVED_KNOT = "EngravedKnotFreeform",
  ENGRAVED_CONVERGE = "EngravedConvergeFreeform",
  ENGRAVED_CONVERGE_90 = "EngravedConverge90Freeform",
  ENGRAVED_CONVERGE_180 = "EngravedConverge180Freeform",
  ENGRAVED_CONVERGE_270 = "EngravedConverge270Freeform",
  ENGRAVED_CONVERGE_VERTICAL = "EngravedConvergeVerticalFreeform",
  ENGRAVED_CONVERGE_VERTICAL_90 = "EngravedConvergeVertical90Freeform",
  ENGRAVED_OFFSET = "EngravedOffsetFreeform",
  ENGRAVED_OFFSET_90 = "EngravedOffset90Freeform",
  ENGRAVED_OFFSET_180 = "EngravedOffset180Freeform",
  ENGRAVED_OFFSET_270 = "EngravedOffset270Freeform",
  ENGRAVED_TOPO = "EngravedTopoFreeform",
  ENGRAVED_TOPO_90 = "EngravedTopo90Freeform",
  ENGRAVED_TOPO_180 = "EngravedTopo180Freeform",
  ENGRAVED_TOPO_270 = "EngravedTopo270Freeform",
  ENGRAVED_ARC = "EngravedArcFreeform",
  ENGRAVED_ARC_90 = "EngravedArc90Freeform",
  ENGRAVED_LARGE_PARALLEL = "EngravedLargeParallelFreeform",
  ENGRAVED_LARGE_PARALLEL_90 = "EngravedLargeParallel90Freeform",
  ENGRAVED_RIVER = "EngravedRiverFreeform",
  ENGRAVED_RIVER_90 = "EngravedRiver90Freeform",
  ENGRAVED_SUBWAY = "EngravedSubwayFreeform",
  ENGRAVED_SUBWAY_90 = "EngravedSubway90Freeform",
  ENGRAVED_SUBWAY_180 = "EngravedSubway180Freeform",
  ENGRAVED_SUBWAY_270 = "EngravedSubway270Freeform",
  ENGRAVED_ZEN = "EngravedZenFreeform",
  ENGRAVED_ZEN_90 = "EngravedZen90Freeform",
  ENGRAVED_ZEN_180 = "EngravedZen180Freeform",
  ENGRAVED_ZEN_270 = "EngravedZen270Freeform",
}
